/**
 * Determines whether the element `a` is an ancestor of the element `b`.
 */
const isAncestor = (a, b) => {
  const {
    parentElement
  } = b;
  if (!parentElement) {
    return false;
  }
  if (a === parentElement) {
    return true;
  }
  return isAncestor(a, parentElement);
};

export { isAncestor as i };
